// extracted by mini-css-extract-plugin
module.exports = {"sticky_bottom_overlay":"StickyBottomOverlay_sticky_bottom_overlay___gUjl","slide-up":"StickyBottomOverlay_slide-up__9czMz"};